import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireContract } from '~/utils/guards';

/** Layout route: all /onboarding/integration/google/** require a LIVE google-ads contract. */
export const Route = createFileRoute('/_authenticated/_tenant/onboarding/integration/google')({
  beforeLoad: requireContract('google', ['LIVE']),
  component: () => <Outlet />,
});
